<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/threedetailedhappyreturn/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
      downloadPower="/threedetailedhappyreturn/PeopleExport"
      :showDownloadPower="true"
      @down="down"
      showDownloadPowerType="warning"
    >
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.memId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="代理商手机号">
        <el-input
          v-model="formModel.phoneNumber"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户号">
        <el-input
          v-model="formModel.merchantNo"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户手机号">
        <el-input
          v-model="formModel.merchantPhone"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="memId"
        label="代理商ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="代理商姓名"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phoneNumber"
        label="代理商手机号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="sn"
        label="SN号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merchantNo"
        label="商户号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merchantName"
        label="商户名称"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merchantPhone"
        label="商户手机号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="jxsId"
        label="经销商ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="jxsMoney"
        label="经销商金额"
        :formatter="formatterTableNumber"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="hjId"
        label="黄金ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="hjMoney"
        label="黄金金额"
        :formatter="formatterTableNumber"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="BjId"
        label="白金ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="BjMoney"
        label="白金金额"
        :formatter="formatterTableNumber"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="zsId"
        label="钻石ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="zsMoney"
        label="钻石金额"
        :formatter="formatterTableNumber"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="operationAmt"
        label="金额(元)"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      ></el-table-column>
      <el-table-column
        prop="operationIntegral"
        label="积分"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="realityTransactions"
        label="达标交易量"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      ></el-table-column>
      <el-table-column
        prop="qualifiedTransactions"
        label="实际交易量"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      ></el-table-column>
      <el-table-column
        prop="startDate"
        label="开始日期"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="endDate"
        label="结束日期"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTablestatus"
      >
      </el-table-column>
      <el-table-column
        fixed="right"
        prop="createTime"
        label="操作时间"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import TransactionService from "service/TransactionService";
import StatisticsService from "service/StatisticsService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "threedetailedhappyreturn",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      formModel: {
        memId: "",
        phoneNumber: "",
        merchantNo: "",
        merchantPhone: "",
        time: "",
        status: "",
      },
      tableData: [],
      submitService: TransactionService.threedetailedhappyreturnlist,
      params: {},
      status: [
        {
          id: "",
          name: "全部",
        },
        {
          id: "0",
          name: "未启动",
        },
        {
          id: "1",
          name: "进行中",
        },
        {
          id: "2",
          name: "未完成",
        },
        {
          id: "3",
          name: "已完成",
        },
      ],
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      const params = {
        memId: this.formModel.memId,
        phoneNumber: this.formModel.phoneNumber,
        merchantNo: this.formModel.merchantNo,
        merchantPhone: this.formModel.merchantPhone,
        status: this.formModel.status,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.time.length) {
        params.startDate = this.formModel.time[0];
        params.endDate = this.formModel.time[1];
      }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        time: "",
        status: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    down() {
      // this.limitExport(this.page.total)
      //   ? StatisticsService.exportExcel(
      //       this.submitData,
      //       "exportHlfInfo",
      //       "8885",
      //       "/hlf/t-hlf-info-dtl/"
      //     )
      //   : "";
    },
    formatterTablestatus(row, column, cellValue, index) {
      let value = "--";
      this.status.forEach((item) => {
        if (item.id == cellValue) {
          value = item.name;
        }
      });
      return value;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/Transaction/ThreeDetailedHappyReturn.vue